@if(input_color()=== 'white'){
<div class="counter_container_left counter_container--white">
  <div class="left">
    <button (click)="MinusClicked()">-</button>
  </div>
  <div class="counter_displayer">{{ number }}</div>
  <div class="right">
    <button (click)="PlusClicked()" class="right">+</button>
  </div>
</div>
} @else if(input_color() === 'blue'){
<div class="counter_container counter_container--blue">
  <div class="left">
    <button class="left--blue" (click)="MinusClicked()">-</button>
  </div>
  <div class="counter_displayer counter_displayer--blue">{{ number }}</div>
  <div class="right">
    <button (click)="PlusClicked()" class="right right--blue">+</button>
  </div>
</div>
}
